<template>
  <div class="dashboard-layout">
    <main-navbar></main-navbar>
    <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
      <notifications></notifications>
      <side-bar
        :mini="false"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <user-menu></user-menu>
        <mobile-menu></mobile-menu>
        <template slot="links">
          <!-- <div class="section_wpr">
            New <i class="md-icon">keyboard_double_arrow_down</i>
          </div>-->
          <div class="profiles" :class="{ open: isBtn }">
            <sidebar-item
              v-if="!isAcademic"
              class="sidebar-item-plus dark-blue-back-ground-color-side-bar"
              :link="{
                name: 'Prospect Search',
                icon: 'source',
                path: '/prospect-search',
              }"
            ></sidebar-item>
            <div
              v-on:click="profileDrop = !profileDrop"
              :class="profileDrop ? 'dropdwn_btn active' : 'dropdwn_btn'"
            >
              <i class="md-icon side-bar-research-item">business_center</i>
              <p class="side-bar-research-item">Research</p>
            </div>
            <ul class="drop_down" v-if="profileDrop">
              <div :class="isFinancialProfile ? '' : 'in-active disable'">
                <sidebar-item
                  class="sidebar-item-plus dark-blue-back-ground-color-side-bar"
                  :link="{
                    name: 'Industry Financial',
                    icon: 'card_travel',
                    path: '/new-profile/industry-financial-profile',
                  }"
                ></sidebar-item>
              </div>
              <div :class="isMarketProfile ? '' : 'in-active disable'">
                <sidebar-item
                  class=" dark-blue-back-ground-color-side-bar"
                  @click.native="changeCollapse"
                  :iconStyle="collapse ? 'color: blue' : ''"
                  :link="{
                    name: 'Industry Market',
                    icon: 'leaderboard',
                    path: '/new-profile/industry-market-profile',
                  }"
                ></sidebar-item>
              </div>
              <div :class="isCompanyProfile ? '' : 'in-active disable'">
                <sidebar-item
                  class=" dark-blue-back-ground-color-side-bar"
                  :link="{
                    name: 'Company',
                    icon: 'business',
                    path: '/company-search',
                  }"
                ></sidebar-item>
              </div>
              <!--<div class="in-active disable">
                <sidebar-item
                  class=" dark-blue-back-ground-color-side-bar"
                  :link="{
                    name: 'Market',
                    icon: 'insights',
                    path: '',
                  }"
                ></sidebar-item>
                <sidebar-item
                  :link="{
                    name: 'Franchise',
                    icon: 'store',
                    path: '',
                  }"
                ></sidebar-item>
              </div>-->
              <!-- <sidebar-item
                  :link="{
                    name: 'Valuation Multiples',
                    icon: 'addchart',
                    path: '/valuation-multiple',
                  }"
                ></sidebar-item>
              -->
            </ul>
            <div
              v-if="!isAcademic"
              v-on:click="reportDrop = !reportDrop"
              class="purple" :class="reportDrop ? 'dropdwn_btn active' : 'dropdwn_btn'"
            >
              <i class="md-icon side-bar-analyze-item">laptop_chromebook</i>
              <p class="side-bar-analyze-item">Analyze</p>
            </div>
            <ul class="drop_down" v-if="reportDrop">
              <div v-if="!isAcademic" :class="isFinancialReport? '' : 'in-active disable'">
                <sidebar-item
                  class=" dark-blue-back-ground-color-side-bar"
                  :link="{
                    name: 'Financial Report',
                    icon: 'text_snippet',
                    path: '/create-report-format/financial',
                  }"
                ></sidebar-item>
              </div>
              <div v-if="!isAcademic" :class="isMarketReport? '' : 'in-active disable'">
                <sidebar-item
                  class=" dark-blue-back-ground-color-side-bar"
                  :link="{
                    name: 'Market Report',
                    icon: 'newspaper',
                    path: '/create-report-format/market',
                  }"
                ></sidebar-item>
              </div>
              <div v-if="!isAcademic" :class="isValuationReport? '' : 'in-active disable'">
                <sidebar-item
                  class=" dark-blue-back-ground-color-side-bar"
                  :link="{
                    name: 'Valuation Report',
                    icon: 'request_quote',
                    path: '/create-report-format/valuation',
                  }"
                ></sidebar-item>
              </div>
              <div v-if="!isAcademic" :class="isCompanyReport? '' : 'in-active disable'">
                <sidebar-item
                  class=" dark-blue-back-ground-color-side-bar"
                  :link="{
                    name: 'Company Report',
                    icon: 'summarize',
                    path: '/create-report-format/company',
                  }"
                ></sidebar-item>
              </div>
            </ul>
          </div>
          <div class="section_wpr dark-blue-back-ground-color-side-bar">
            My Data
            <i class="md-icon dark-blue-back-ground-color-side-bar">expand_more</i>
          </div>
          <div class="profiles border-0">
            <router-link v-if="!isAcademic" to="/my-prospect-lists" class>
              <md-tooltip md-direction="right" class="width-tooltip">Prospect Lists</md-tooltip>
              <span v-on:click="myProspect" class="dropdwn_btn">
                <i class="md-icon dark-blue-back-ground-color-side-bar">format_list_bulleted</i>
                <p class="dark-blue-back-ground-color-side-bar">Prospect Lists</p>
              </span>
            </router-link>
            <router-link  to="/my-profiles" class>
              <md-tooltip md-direction="right" class="width-tooltip">Profiles</md-tooltip>
              <span v-on:click="myProfile" class="dropdwn_btn">
                <i class="md-icon dark-blue-back-ground-color-side-bar">folder_open</i>
                <p class="dark-blue-back-ground-color-side-bar">Profiles</p>
              </span>
            </router-link>
            <router-link v-if="!isAcademic" to="/my-reports" class>
              <md-tooltip md-direction="right" class="width-tooltip">Reports</md-tooltip>
              <span v-on:click="myReport" class="dropdwn_btn">
                <i class="md-icon dark-blue-back-ground-color-side-bar">description</i>
                <p class="dark-blue-back-ground-color-side-bar">Reports</p>
              </span>
            </router-link>
            <router-link v-if="!isAcademic" to="/my-data" class>
              <md-tooltip md-direction="right" class="width-tooltip">Saved Inputs</md-tooltip>
              <span v-on:click="myData" class="dropdwn_btn">
                <i class="md-icon dark-blue-back-ground-color-side-bar">dns</i>
                <p class="dark-blue-back-ground-color-side-bar">Saved Inputs</p>
              </span>
            </router-link>
          </div>
          <!-- <div class="profiles" :class="{open:myPro}">
            <span v-on:click="myProfile" class="dropdwn_btn"><i class="md-icon">contact_page</i> Profiles <span class="md-icon">expand_less</span></span>
          </div>
          <div class="profiles" :class="{open:myRep}">
            <span v-on:click="myReport" class="dropdwn_btn"><i class="md-icon">description</i> Report <span class="md-icon">expand_less</span></span>
          </div>
          <div class="profiles" :class="{open:myDT}">
            <span v-on:click="myData" class="dropdwn_btn"><i class="md-icon">storage</i> Data <span class="md-icon">expand_less</span></span>
          </div>-->

          <sidebar-item
            :key="'tab0' + this.refreshKey"
            v-if="collapse && financialProfileFavourite !== null"
            @click.native="changeCollapse"
            style="padding-left: 56px"
            :link="{
              name: `${financialProfileFavourite.split('#')[0]}`,
              icon: '',
              path: { name: 'NewProfile' },
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="collapse && salesPerFootFavourite !== null"
            @click.native="changeCollapse"
            style="padding-left: 56px"
            :link="{
              name: `${salesPerFootFavourite.split('#')[0]}`,
              icon: '',
              path: { name: 'NewProfile' },
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="collapse && marketProfileFavourite !== null"
            @click.native="changeCollapse"
            style="padding-left: 56px"
            :link="{
              name: `${marketProfileFavourite.split('#')[0]}`,
              icon: '',
              path: { name: 'NewMarketProfile' },
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="collapse && companyProfilesFavourite !== null"
            @click.native="changeCollapse"
            style="padding-left: 56px"
            :link="{
              name: `${companyProfilesFavourite.split('#')[0]}`,
              icon: '',
              path: { name: 'FindCompanies' },
            }"
          ></sidebar-item>

          <sidebar-item
            v-if="collapse && financialReportFavourite !== null"
            @click.native="changeCollapse"
            style="padding-left: 56px"
            :link="{
              name: `${financialReportFavourite.split('#')[0]}`,
              icon: '',
              path: { name: 'IFFinanicalReport', params: { id: 32523623 } },
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="collapse && marketReportFavourite !== null"
            @click.native="changeCollapse"
            style="padding-left: 56px"
            :link="{
              name: `${marketReportFavourite.split('#')[0]}`,
              icon: '',
              path: { name: 'MRCompetitiveSummary', params: { id: 32523623 } },
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="collapse && vestimateReportFavourite !== null"
            @click.native="changeCollapse"
            style="padding-left: 56px"
            :link="{
              name: `${vestimateReportFavourite.split('#')[0]}`,
              icon: '',
              path: { name: 'VRBusinessValue', params: { id: 32523623 } },
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="collapse && companyReportFavourite !== null"
            @click.native="changeCollapse"
            style="padding-left: 56px"
            :link="{
              name: `${companyReportFavourite.split('#')[0]}`,
              icon: '',
              path: { name: 'CRSwotSummary', params: { id: 32523623 } },
            }"
          ></sidebar-item>
          <sidebar-item
            class="sidebar-footer-mobile"
            :link="{
              name: 'Blog',
              icon: 'feed',
              path: '/blog',
            }"
          ></sidebar-item>
        </template>
      
      </side-bar>
      <div class="main-panel">
        <top-navbar></top-navbar>

        <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
          <zoom-center-transition :duration="200" mode="out-in">
            <!-- your content here -->
            <router-view />
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}

function initSidebar() {
  document.body.classList.toggle('sidebar-mini');
}

import TopNavbar from './TopNavbar.vue';
import MainNavbar from './MainNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import UserMenu from './Extra/UserMenu.vue';
import Vuex from 'vuex';

export default {
  components: {
    TopNavbar,
    MainNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu,
  },
  data() {
    return {
      profileDrop: true,
      reportDrop: true,
      isBtn: true,
      myPro: false,
      myRep: false,
      myProsp: false,
      myDT: false,
      collapse: false,
      isFinancialProfile: false,
      isFinancialReport: false,
      isMarketProfile: false,
      isMarketReport: false,
      isCompanyReport: false,
      isCompanyProfile: false,
      isValuationReport: false,
      financialProfileFavourite: localStorage.getItem(
        'financial-profile-favourite'
      ),
      salesPerFootFavourite: localStorage.getItem('sales-per-foot-favourite'),
      marketProfileFavourite: localStorage.getItem('market-profile-favourite'),
      companyProfilesFavourite: localStorage.getItem(
        'company-profiles-favourite'
      ),
      financialReportFavourite: localStorage.getItem(
        'financial-report-favourite'
      ),
      marketReportFavourite: localStorage.getItem('market-report-favourite'),
      vestimateReportFavourite: localStorage.getItem(
        'vestimate-report-favourite'
      ),
      companyReportFavourite: localStorage.getItem('company-report-favourite'),
      showFavorites: false,
      sidebarBackgroundColor: 'grey',
      sidebarBackground: 'green',
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + '/img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      roles: [],
    };
  },

  methods: {
    checkSubscriptions: function () {
      if (this.isRetail || this.isAcademic) {
         this.isFinancialProfile = true;
        this.isFinancialReport = true;
        this.isMarketProfile = true;
        this.isMarketReport = true;
        this.isCompanyReport = true;
        this.isCompanyProfile = true;
        this.isValuationReport = true;
      } else {
        if (this.subscriptions.includes('usif') || this.subscriptions.includes('lif')|| this.subscriptions.includes('usif_p')|| this.subscriptions.includes('lif_p'))
          this.isFinancialProfile = true;
        
        if (this.subscriptions.includes('usif') || this.subscriptions.includes('lif')|| this.subscriptions.includes('usif_r')|| this.subscriptions.includes('lif_r'))
          this.isFinancialReport = true;

        if (this.subscriptions.includes('usmr') || this.subscriptions.includes('lmr')|| this.subscriptions.includes('usmr_p')|| this.subscriptions.includes('lmr_p'))
          this.isMarketProfile = true;

        if (this.subscriptions.includes('usmr') || this.subscriptions.includes('lmr')|| this.subscriptions.includes('usmr_r')|| this.subscriptions.includes('lmr_r'))
          this.isMarketReport = true;

        if (this.subscriptions.includes('swot'))
          this.isCompanyReport = true;

        if (this.subscriptions.includes('css'))
          this.isCompanyProfile = true;

        if (this.subscriptions.includes('vpro'))
          this.isValuationReport = true;
      }
    },
    changeCollapse: function () {
      this.collapse = !this.collapse;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    toggleSec() {
      this.isBtn = !this.isBtn;
    },
    myProfile() {
      this.myPro = !this.myPro;
    },
    myReport() {
      this.myRep = !this.myRep;
    },
    myProspect() {
      this.myProsp = !this.myProsp;
    },
    myData() {
      this.myDT = !this.myDT;
    },
  },
  mounted() {
    if(this.isAcademic)
      this.checkSubscriptions()  
    // reinitScrollbar();
    // initSidebar();
  },
  updated() {
     if ((this.subscriptions && this.subscriptions.length>0) || this.isRetail || this.isAcademic)     
      this.checkSubscriptions()      
    
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
      subscriptions: (state) => state?.user?.user_subscriptions,
      isRetail: (state) => (state.user.user_type.retail/* || state.user.allow_retail*/) ?true: null,
      isAcademic: (state) => state.user.user_type.academic ?? null,
      isSubscriber: (state) => state.user.user_type.subscriber ?? null,
      isIBBA2021:  (state) => state.user.user_IBBA2021 ?? null,
    }),
    refreshKey() {
      return this.$store.getters.refreshKey;
    },
  },

  watch: {
    refreshKey() {
      this.financialProfileFavourite = localStorage.getItem(
        'financial-profile-favourite'
      );
      this.salesPerFootFavourite = localStorage.getItem(
        'sales-per-foot-favourite'
      );
      this.marketProfileFavourite = localStorage.getItem(
        'market-profile-favourite'
      );
      this.companyProfilesFavourite = localStorage.getItem(
        'company-profiles-favourite'
      );
      this.financialReportFavourite = localStorage.getItem(
        'financial-report-favourite'
      );
      this.marketReportFavourite = localStorage.getItem(
        'market-report-favourite'
      );
      this.vestimateReportFavourite = localStorage.getItem(
        'vestimate-report-favourite'
      );
      this.companyReportFavourite = localStorage.getItem(
        'company-report-favourite'
      );
    },
    subscriptions() {
     if ((this.subscriptions && this.subscriptions.length>0) || this.isRetail || this.isAcademic)     
        this.checkSubscriptions()
    },
    me: {
      handler: function (val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
